export const AccountType = {
  ADMIN: "admin",
  BRAND: "brand",
  DISTRIBUTOR: "distributor",
  IMPORTER: "importer",
};

export const SourceType = {
  QUICKBOOKS: "quickbooks",
  FAIRE: "faire",
  MANUAL: "manual",
  PUBLIC_API: "public-api",
};

export const ActivityType = {
  // for brand
  NewBuyer: "new_buyer",
  NewDistributor: "new_distributor",
  DailyOrderSync: "daily_order_sync",
  WeeklyOrderSync: "weekly_order_sync",
  ProductPurchase: "product_purchase",
  // for distributor
  OrderPurchase: "orders_placed",
  FallOffs: "fall_offs",
  NewCustomers: "new_customers_added",
};

export const SourceOptions = [
  { id: SourceType.QUICKBOOKS, label: "Quickbooks" },
  { id: SourceType.FAIRE, label: "Faire" },
  { id: SourceType.MANUAL, label: "Manual" },
  { id: SourceType.PUBLIC_API, label: "PublicAPI" },
];

export const ExternalOrderHeaders = [
  "Order Id",
  "Order Date",
  "Product Name",
  "SKU",
  "Description",
  "Unit Price",
  "Quantity",
  "Buyer Name",
  "City",
  "Country",
  "Country Code",
  "Country Sub Division Code",
  "Line 1",
  "Line 2",
  "Postal Code",
  "State",
];

export const PerBuyerCost = 1;

export const UnassociatedProductsSourceOptions = [
  { id: 1, name: "Quickbooks" },
  { id: 2, name: "Public API" },
];

export const CustomersAgingSourceOptions = [
  { id: 1, name: "0-7" },
  { id: 2, name: "8-14" },
  { id: 3, name: "15-30" },
  { id: 4, name: "31-168" },
  { id: 5, name: ">168" },
];

export const UnassociatedProductsSource = {
  Quickbooks: "Quickbooks",
  PublicAPI: "Public API",
};
